// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1bXMP","boxTitle":"Qualiphy_boxTitle__4hT9n","box":"Qualiphy_box__3uwnV","toggleWrap":"Qualiphy_toggleWrap__NgG44"};